import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadDisabledIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1833_3930",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 16,
		height: 16,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1833_3930)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.6875 10.75V4.12813L5.575 6.24063L4.4375 5.0625L8.5 1L12.5625 5.0625L11.425 6.24063L9.3125 4.12813V10.75H7.6875ZM3.625 14C3.17813 14 2.79557 13.8409 2.47734 13.5227C2.15911 13.2044 2 12.8219 2 12.375V9.9375H3.625V12.375H13.375V9.9375H15V12.375C15 12.8219 14.8409 13.2044 14.5227 13.5227C14.2044 13.8409 13.8219 14 13.375 14H3.625Z",
			fill: "#C2C6D4"
		})
	})]
});
export default SvgUploadDisabledIcon;
